import type { GameReportInput, GameReportResult } from '@/types';
import { ApiError } from '@/features/bet-inspection/lib/api';

/** POST {api}/game-reports — per-bet history for a game over a period. */
export async function fetchGameReport(params: {
  api: string;
  token: string | null;
  input: GameReportInput;
  signal?: AbortSignal;
}): Promise<GameReportResult> {
  const base = params.api.replace(/\/+$/, '');

  let res: Response;
  try {
    res = await fetch(`${base}/game-reports`, {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        ...(params.token ? { authorization: `Bearer ${params.token}` } : {}),
      },
      body: JSON.stringify(params.input),
      signal: params.signal,
    });
  } catch (err) {
    if ((err as Error)?.name === 'AbortError') throw err;
    throw new ApiError(`Could not reach the betlens API at ${base}.`, 0);
  }

  if (!res.ok) {
    const body = (await res.json().catch(() => null)) as { error?: string } | null;
    throw new ApiError(body?.error ?? `Request failed (${res.status})`, res.status);
  }

  return (await res.json()) as GameReportResult;
}
